import React from "react";
import styled from "styled-components";

const PulseAnimatedSvg = styled.svg`
  animation: pulse 2s infinite;
  border-radius: 50%;

  @keyframes pulse {
    0% {
      transform: scale(1);
      box-shadow: 0 0 0 0 rgba(0, 105, 255, 0.4);
    }
    70% {
      transform: scale(1.1);
      box-shadow: 0 0 0 10px rgba(0, 105, 255, 0);
    }
    100% {
      transform: scale(1);
      box-shadow: 0 0 0 0 rgba(0, 105, 255, 0);
    }
  }
`;

const SearchIcon = () => {
  return (
    <PulseAnimatedSvg
      width="20px"
      height="20px"
      viewBox="0 0 20 20"
      version="1.1"
      xmlns="http://www.w3.org/2000/PulseAnimatedSvg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g id="--------↳-Map" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="marker-place" fillRule="nonzero">
          <path
            d="M10,0 C4.4771525,0 0,4.4771525 0,10 C0,15.5228475 4.4771525,20 10,20 C15.5228475,20 20,15.5228475 20,10 C20,4.4771525 15.5228475,0 10,0 Z"
            id="Path"
            fill="#0060C9"
          ></path>
          <path
            d="M10,0 C4.4771525,0 0,4.4771525 0,10 C0,15.5228475 4.4771525,20 10,20 C15.5228475,20 20,15.5228475 20,10 C20,4.4771525 15.5228475,0 10,0 Z M10,2 C14.418278,2 18,5.581722 18,10 C18,14.418278 14.418278,18 10,18 C5.581722,18 2,14.418278 2,10 C2,5.581722 5.581722,2 10,2 Z"
            id="search_result"
            fill="#FFFFFF"
          ></path>
          <path
            d="M10,6 C8.34142857,6 7,7.252 7,8.8 C7,10.9 10,14 10,14 C10,14 13,10.9 13,8.8 C13,7.252 11.6585714,6 10,6 L10,6 Z M10,10 C9.448,10 9,9.552 9,9 C9,8.448 9.448,8 10,8 C10.552,8 11,8.448 11,9 C11,9.552 10.552,10 10,10 L10,10 Z"
            id="Location"
            fill="#FFFFFF"
          ></path>
        </g>
      </g>
    </PulseAnimatedSvg>
  );
};

export default SearchIcon;
